module.exports = __webpack_public_path__ + "static/media/Trivy-logo.aa4fe9be.png";